import { LitElement, html, css } from 'lit';
import { restMethods } from '../mixins/rest_methods'

class BookmarkButton extends LitElement {
  static properties = {
    facilityId: { type: Number },
    facilityIsBookmark: { type: Boolean, reflect: true },
    isUnlogin: { type: Boolean, reflect: true },
    isBookmark: { type: Boolean, reflect: true },
  }

  static styles = css`
    .bookmark-icon {
      img {
        width: 44px;
        height: 44px;
      }
    }
  `;

  constructor() {
    super();
    this.facilityIsBookmark = false;
    this.isBookmark = this.facilityIsBookmark;
  }

  async createBookmark() {
    try {
      if (this.isUnlogin) {
        window.location.href = '/login';
        return;
      }
      await restMethods.methods.postMethod(`/facilities/${this.facilityId}/create_bookmark`, {});
      this.isBookmark = true;
    } catch (e) {
      console.error("作成に失敗しました", e);
    }
  }

  async deleteBookmark() {
    try {
      if (this.isUnlogin) {
        window.location.href = '/login';
        return;
      }
      await restMethods.methods.deleteMethod(`/facilities/${this.facilityId}/delete_bookmark`, {});
      this.isBookmark = false;
    } catch (e) {
      console.error("削除に失敗しました", e);
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('facilityIsBookmark')) {
      this.isBookmark = this.facilityIsBookmark;
    }
  }

  render() {
    return html`
      <div class="bookmark-icon" @click="${this.isBookmark ? this.deleteBookmark : this.createBookmark}">
        ${this.isBookmark ? html`
          <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
            <g filter="url(#filter0_d_280_909)">
              <circle cx="22" cy="22" r="18" fill="white"/>
              <path d="M28.1264 18.7126L25.0921 15.6825L26.4675 14.2866L28.1264 15.9455L32.045 12L33.441 13.3959L28.1264 18.7126ZM14 32V14.1269C14 13.5712 14.2007 13.0919 14.6022 12.6891C15.0036 12.2862 15.4822 12.0848 16.0379 12.0848H24.5316C24.1314 12.5793 23.8258 13.0965 23.615 13.6365C23.4041 14.1764 23.2986 14.7638 23.2986 15.3987C23.2986 16.6345 23.6881 17.7181 24.4671 18.6497C25.2461 19.5813 26.2194 20.1662 27.387 20.4042C27.7607 20.469 28.0985 20.5013 28.4006 20.5013C28.7027 20.5013 29.0455 20.469 29.4292 20.4042V32L21.7124 28.699L14 32Z" fill="#EBAE1D"/>
            </g>
            <defs>
              <filter id="filter0_d_280_909" x="0" y="0" width="44" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.16 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_280_909"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_280_909" result="shape"/>
              </filter>
            </defs>
          </svg>
        `: html`
          <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
            <g filter="url(#filter0_d_4013_9261)">
              <circle cx="22" cy="22" r="18" fill="white"/>
              <path d="M14 32V14.0508C14 13.4915 14.2015 13.0098 14.6046 12.6059C15.0077 12.202 15.4883 12 16.0465 12H24.5765C24.1745 12.4966 23.8676 13.0157 23.6559 13.5573C23.4441 14.099 23.3382 14.6892 23.3382 15.328C23.3382 16.5679 23.7294 17.6559 24.5116 18.5921C25.2939 19.5282 26.2714 20.1158 27.444 20.3549C27.8192 20.4199 28.1585 20.4524 28.4619 20.4524C28.7653 20.4524 29.1096 20.4199 29.4948 20.3549V32L21.7453 28.6849L14 32ZM27.4806 18.656V16.3147H25.1393V14.3478H27.4806V12.0065H29.4518V14.3478H31.7931V16.3147H29.4518V18.656H27.4806Z" fill="#A8ABA6"/>
            </g>
            <defs>
              <filter id="filter0_d_4013_9261" x="0" y="0" width="44" height="46" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.16 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4013_9261"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4013_9261" result="shape"/>
              </filter>
            </defs>
          </svg>
        `}
      </div>
    `;
  }
}

customElements.define('bookmark-button', BookmarkButton);